// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__2JulI","step":"Breadcrumb_step__3UyxA","small":"Breadcrumb_small__2ebJv"};